import { FC, useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { resetRedirection } from 'src/store/auth/auth.slice';
import Navigation, { TNavigation } from 'src/components/navigation/Navigation';
import './protectedLayout.scss';
import { useGetIdentity } from 'src/hooks';
import useSideNavigationItems from 'src/components/navigation/useSideNavigationItems';
import { getTeamCohort } from 'src/store/cohort/cohort.slice';
import { TCreateMVPRequest } from 'src/services/apiEndpoint.types.ts/ideaHub/createIdea.endpoint.types';
import { createMVP } from 'src/store/ideaHub/createMVP.thunk';

const ProtectedLayout: FC = () => {
  // Hooks
  const { shouldRedirectToLogin, shouldRedirectToAccessDenied } = useAppSelector(
    (store) => store.auth
  );
  const { notificationCount, chatCount } = useAppSelector(
    (store) => store.chat
  );
  const { viewUserCohort } = useAppSelector(
    (store) => store.cohort
  );
  const { isAuthorized } = useAppSelector((store) => store.auth);
  const { profile } = useAppSelector((store) => store.profile);
  const { myCompany } = useAppSelector((store) => store.company);
  const email = profile?.email || myCompany?.email;
  const userType = profile?.email ? 'User' : 'Company';
  const {
    id: userId,
    role: userRole,
    onboardingComplete
  } = useAppSelector((store) => store.profile.profile);

  const sideNavItems = useSideNavigationItems();

  const [items, setItems] = useState<Array<TNavigation>>(sideNavItems);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { getIdentities } = useGetIdentity();
  const exculdedPath = ['/dashboard', '/settings', '/my-profile', '/startup-onboarding', '/termsandconditions', '/startup-payment', '/investor', '/scoring', '/score', '/demo-day', '/demo-day-register', '/demo-day-register/payment', '/demo-day-register/document-submission', '/demo-day-register/slot-booking', '/demo-day-register/success', '/demo-day-detail', '/not-found']
  const isSidebarInclude = useMemo(() => {
    return !exculdedPath.includes(location.pathname)
  }, [location])

  const redirectIfRoleIsNotCreated = () => {
    const { loggedInUserType } = getIdentities();
    const isUser = loggedInUserType === 'User';
    if (isUser && userId && !onboardingComplete) {
      navigate('/onboarding-user-type');
    }
  };
  useEffect(() => {
    if (userId) {
      // dispatch(getTeamCohort({ userId }))
    }
  }, [JSON.parse(JSON.stringify(userId))])

  useEffect(() => {
    const arr: TNavigation[] = [];
    sideNavItems.forEach((item) => {
      item.state = item.state === 'disabled' ? 'disabled' : 'default';
      if (location.pathname.includes(item.url)) item.state = 'active';

      if (item.key !== 'cohort' || (item.key === 'cohort' && viewUserCohort)) {
        if (item.key === 'cohort') {
          const teamId = viewUserCohort?.CohortTeamsAndTeamMemberMappings?.[0]?.cohortTeamId
          arr.push({ ...item, url: `/cohort?id=${viewUserCohort.id}&userId=${userId}&teamId=${teamId}` })
        } else {
          arr.push(item)
        }
      }
    });
    setItems(arr);
  }, [location, notificationCount, chatCount, viewUserCohort, sideNavItems]);
  const [loading, setLoading] = useState<boolean>(false)
  function handleNavigateToMVP() {
    const payload: TCreateMVPRequest = {
      email,
      userType
    }
    setLoading(true)
    dispatch(createMVP(payload)).then((response: any) => {
      setLoading(false)
      if (response?.data?.data?.tokenUrl) {
        window.open(response?.data?.data?.tokenUrl)
      }
    }).finally(() => setLoading(false))
  }

  useEffect(() => {
    if (shouldRedirectToLogin) {
      navigate('/login');
    }
    return () => {
      dispatch(resetRedirection());
    };
  }, [shouldRedirectToLogin]);

  useEffect(() => {
    if (shouldRedirectToAccessDenied) {
      navigate('/startup-onboarding');
    }
    return () => {
      dispatch(resetRedirection());
    };
  }, [shouldRedirectToAccessDenied]);

  useEffect(() => {
    if (userRole) {
      redirectIfRoleIsNotCreated();
    }
  }, [userRole, onboardingComplete]);
  return (
    <div className="protected-layout">
      {isAuthorized && isSidebarInclude && <Navigation items={items} handleNavigateToMVP={handleNavigateToMVP} loading={loading} />}
      <div className="protected-layout__right">
        <Outlet />
      </div>
    </div>
  );
};

export default ProtectedLayout;
